import clsx from 'clsx'

import {CloseButton} from './CloseButton'
import {DrawerContextConsumer} from './context'
import {MobileDrawerBase, MobileDrawerBaseProps} from './MobileDrawer'
import {classes} from './Simple.classes'

export type MobileDrawerSimpleProps = MobileDrawerBaseProps & {
  /** Нужно ли отключить кнопку "назад". `always` - отключить, `whenOpened` - отключить когда дровер развернут, `never` - всегда показывать
   *  @default "never"
   **/
  disableCloseButton?: 'always' | 'whenOpened' | 'never'
}

export const MobileDrawerSimple = ({
  children,
  disableCloseButton = 'never',
  topOffset: topOffsetProp = 0,
  outsideContent,
  className,
  ...props
}: MobileDrawerSimpleProps) => {
  // Прибавляем отступ для кнопки если она есть
  const topOffset = topOffsetProp + (disableCloseButton !== 'never' ? 0 : 64)

  return (
    <MobileDrawerBase
      {...props}
      {...{topOffset}}
      outsideContent={
        <>
          <DrawerContextConsumer>
            {({isFullSize, opened}) =>
              (disableCloseButton === 'never' || (disableCloseButton === 'whenOpened' && !isFullSize)) &&
              opened && <CloseButton />
            }
          </DrawerContextConsumer>
          {outsideContent}
        </>
      }
    >
      <div className={classes.paperBackground} />
      <div className={clsx(className, classes.paper)}>{children}</div>
    </MobileDrawerBase>
  )
}
